/*
 * @Author: Src
 * @Date: 2024-10-10 15:39:20
 * @LastEditTime: 2025-12-08 15:07:12
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/brand_service.ts
 * @Description: 头部注释配置模板
 */
import { inject, injectable } from 'inversify';
import HttpClient from './http.service';

@injectable()
export class BrandService {
  @inject(HttpClient)
  protected http!: HttpClient;

  /** 品牌列表 */
  async list(
    params: {
      pageSize?: number;
      page: number;
    },
    loadingEl?: Element | Vue,
  ) {
    try {
      const res = (await this.http.get('shop/brand/list', {
        params,
        data: { loadingEl },
      })) as {
        lastPage: number;
        page: number;
        pageSize: string;
        total: number;
        list: Array<{
          brand_code: string;
          create_time: string;
          header_pic: string;
          is_auto_payment: number;
          logo: string;
          name: string;
          owner_id: string;
          protection_rules: string;
          shop_count: number;
          staff_id: number;
        }>;
      };

      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 品牌新增 */
  async create(
    params: {
      name: string;
      owner_id: string;
      staff_id: string;
      brand_code: string;
      header_pic: number;
      webhook_url: string;
      logo: string;
      videos: any;
      withdrawal_account_name: string;
      withdrawal_account: string;
      brand_type: number;
    },
    loadingEl?: Element | Vue,
  ) {
    const url = 'shop/brand/new-create';
    try {
      const res = (await this.http.post(url, {
        ...params,
        data: { loadingEl },
      })) as string;
      return res;
    } catch (error) {
      throw error;
    }
  }


  /** 品牌详情 */
  async brandDetail(ka_id: string) {
    const url = `shop/brand/${ka_id}/detail`;
    try {
      const res = (await this.http.get(url)) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 品牌修改 */
  async updateBrand(
    params: any,
  ) {
    const url = 'shop/brand/edit/info';
    // console.log(params);
    try {
      const res = (await this.http.post(url, params)) as string;
      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 品牌赠送天数 */
  async brandGiftDays(ka_id: string) {
    const url = `shop/query/${ka_id}/gift_days`;
    try {
      const res = (await this.http.get(url)) as string;
      return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAudioList(params: any) {
    try {
      const res = (await this.http.get('brand/audio/list', { params })) as any;
      const dataSource: any = {
        total: res.total,
        list: [],
      };
      dataSource.list = res.list.map((data: any) => {
        // const { duration } = data;
        const _text: any = data;
        _text.duration = 0;
        this.getAudioDurationTime(data.url).then((item: any) => {
          _text.duration = item;
          return _text;
        });
        return _text;
      });
      return dataSource;
    } catch (error) {
      throw error;
    }
  }

  async getAudioDurationTime(url: any) {
    if (!url) {
      return null;
    }
    try {
      const _text: any = await this.getAudioDuration(url).then((res) => {
        return res;
      });
      return _text;
    } catch (error) {
      console.error('获取音频时长失败:', error);
      return null;
    }
  }

  /**
 * 使用 Audio 元素获取音频时长
 * @param audioUrl 音频文件的 URL
 * @returns 音频时长（秒），失败时返回 null
 */
  async getAudioDuration(audioUrl: string): Promise<number | null> {
    return new Promise((resolve) => {
      const audio = new Audio();

      // 监听元数据加载完成事件
      audio.addEventListener('loadedmetadata', () => {
        resolve(audio.duration);
      });

      // 监听错误事件
      audio.addEventListener('error', () => {
        console.error('加载音频失败:', audioUrl);
        resolve(null);
      });

      // 设置音频源并开始加载
      audio.src = audioUrl;
    });
  }


  async brandAudioUpload(params: any) {
    try {
      const res = (await this.http.get('shop/ec/brand/voice', { params })) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAudioPushGd(data: any) {
    try {
      const res = (await this.http.post('brand/audio/push/gd', data)) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }


  async brandAudioVoice(params: any) {
    try {
      const res = (await this.http.get('shop/ec/shop/voice', { params })) as any;

      const dataSource: any = {
        total: res.total,
        list: [],
      };
      dataSource.list = res.list.map((data: any) => {
        // const { duration } = data;
        const _text: any = data;
        _text.duration = 0;
        this.getAudioDurationTime(data.path).then((item: any) => {
          _text.duration = item;
          return _text;
        });
        return _text;
      });
      return dataSource;
      // return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAudioPushVoice(data: any) {
    try {
      const res = (await this.http.post('shop/ec/push_voice', data)) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAlbumKaTemplateList(ka_id: string, params: any) {
    try {
      const res = (await this.http.get(`album/ka/${ka_id}/template/list`, { params })) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAlbumKaTemplateDetail(template_id: string) {
    try {
      const res = (await this.http.get(`album/ka/template/info/${template_id}`)) as string;
      return res;
    } catch (error) {
      throw error;
    }
  }

  async brandAlbumKaTemplateAlbum(album_id: string, params: any) {
    try {
      const res = (await this.http.get(`album/ka/template/album/${album_id}`, { params })) as any;
      return res;
    } catch (error) {
      throw error;
    }
  }


  /**
   * 创建品牌相册模版
   * @param data
   * @returns
   */
  async brandAlbumKaTemplateCreate(data: any) {
    try {
      const res = (await this.http.post('album/ka/template/create', data)) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 编辑品牌相册模版
   * @param data
   * @returns
   */
  async brandAlbumKaTemplateEdit(data: any) {
    try {
      const res = (await this.http.post('album/ka/template/edit', data)) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 复制品牌相册模版
   * @param data
   * @returns
   */
  async brandAlbumKaTemplateCopy(data: any) {
    try {
      const res = (await this.http.post('album/ka/template/copy', data)) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 删除品牌相册模版
   * @param data
   * @returns
   */
  async brandAlbumKaTemplateDelete(data: any) {
    try {
      const res = (await this.http.post('album/ka/template/delete', data)) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 设置默认品牌相册模版
   * @param data
   * @returns
   */
  async brandAlbumKaTemplateSetDefault(data: any) {
    try {
      const res = (await this.http.post('album/ka/template/set/default', data)) as string;
      return res;
    } catch (error) {
      return '';
    }
  }


  /**
   * 相册模版店铺列表
   * @param params
   * @returns
   */
  async brandAlbumKaTemplateShopList(params: any) {
    try {
      const res = (await this.http.get('album/ka/template/shop/list', { params })) as any;
      return res;
    } catch (error) {
      throw '';
    }
  }


  /**
   * 品牌日志列表
   * @param params
   * @returns
   */
  async brandAlbumKaTemplateLog(params: any) {
    try {
      const res = (await this.http.get('album/ka/template/log', { params })) as any;
      return res;
    } catch (error) {
      throw '';
    }
  }

  /**
   * 日志详情
   * @param params
   * @returns
   */
  async brandAlbumKaTemplateLogDetail(params: any) {
    try {
      const res = (await this.http.get('album/ka/template/log/detail', { params })) as any;
      return res;
    } catch (error) {
      throw '';
    }
  }

  async brandAlbumKaTemplateDownloadCsv() {
    try {
      const res = (await this.http.get('album/ka/template/download/csv', { responseType: 'arraybuffer' })) as any;
     const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = '品牌相册模版店铺列表.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return res;
    } catch (error) {
      throw '';
    }
  }
}
